import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import AccountCard from './AccountCard/AccountCard';
import {
  CarouselContainer,
  Carousel,
  ButtonRight,
  ButtonLeft,
  CarouselContent,
  Pagination,
  PageDot,
  AccountCardWrapper
} from './styles';

const Accounts = ({ accounts = [] }) => {
  const [visibleCards, setVisibleCards] = useState(3);
  

  useEffect(() => {
    const handleResize = () => {
      const containerWidth = scrollRef.current?.offsetWidth || 0;

      if (containerWidth < 500) setVisibleCards(1);
      else if (containerWidth < 800) setVisibleCards(2);
      else setVisibleCards(3);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [currentPage, setCurrentPage] = useState(0);
  const scrollRef = useRef(null);
  const itemsPerPage = 3; // Ajuste conforme necessário

  // Verificação de segurança para accounts ser null ou undefined
  const safeAccounts = accounts || [];
  const totalPages = (safeAccounts.length - 2);

  const scroll = (direction) => {
    if (direction === 'left') {
      setCurrentPage(prev => Math.max(0, prev - 1));
    } else {
      setCurrentPage(prev => Math.min(totalPages - 1, prev + 1));
    }
  };

  // Calcular a transformação para mostrar os itens corretos
  const transformValue = `translateX(-${currentPage * (100 / itemsPerPage)}%)`;

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  // Se não houver accounts, mostrar mensagem ou loading
  if (!accounts) {
    return <div>Carregando...</div>;
  }

  return (
    <CarouselContainer>
      <ButtonLeft 
        onClick={() => scroll('left')} 
        disabled={currentPage === 0}
      >
        ‹
      </ButtonLeft>
      
      <Carousel>
        <CarouselContent ref={scrollRef} style={{ transform: transformValue }}>
          {safeAccounts.map((account) => (
            <AccountCardWrapper key={account.address}>
              <AccountCard
                account={account}
              />
            </AccountCardWrapper>
          ))}
        </CarouselContent>
      </Carousel>

      <ButtonRight 
        onClick={() => scroll('right')} 
        disabled={currentPage === totalPages - 1 || totalPages === 0}
      >
        ›
      </ButtonRight>

      {totalPages > 1 && (
        <Pagination>
          {Array.from({ length: totalPages }, (_, index) => (
            <PageDot
              key={index}
              $active={index === currentPage}
              onClick={() => goToPage(index)}
            />
          ))}
        </Pagination>
      )}
    </CarouselContainer>
  );
};

export default Accounts;